import { useCallback, useState, useMemo, useEffect, useRef } from 'react';

import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import moment from 'moment';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';

import {
  InputSearch,
  Table,
  Button,
  ConfirmModal,
  GoBackButton,
  Select,
} from '~/components';
import { useAuth } from '~/hooks/auth.context';
import { useLoading } from '~/hooks/loading';
import { PageOptionsRequest } from '~/models/Common';
import { IPaymentHistory, IUserContract } from '~/models/Contracts';
import { IUser } from '~/models/User';
import { IUserListFilters } from '~/models/UserListFilters';
import ContractsService from '~/services/Contracts';
import PaymentHistoryService from '~/services/PaymentHistory';
import { handleYupValidationError } from '~/utils';
import { applyMask, formatUTCDateToBR } from '~/utils/masks';
import { UserListFiltersSchema } from '~/utils/schemas/UserListFiltersSchema';

import FilterForm from '../UsersList/FilterForm';

import * as S from './styles';
import { ActiveOrInactive } from './styles';

interface IUserDetailsProps {
  id: string;
}

interface IProfessionalDetailsState {
  professionalId: number;
}

interface IContractDetailsState {
  currentContractId: number;
}

const statusPayment = [
  {
    label: 'Pendente',
    value: 'pending',
  },
  {
    label: 'Pago',
    value: 'paid',
  },
  {
    label: 'Não Pago',
    value: 'not_paid',
  },
  {
    label: 'Cancelado',
    value: 'canceled',
  },
  {
    label: 'Atrasado',
    value: 'overdue',
  },
];

const PaymentHistoric = () => {
  const { setLoading } = useLoading();

  const router = useHistory();
  const formRef = useRef<FormHandles>(null);
  const { id: professionalId } = useParams<IUserDetailsProps>();
  const { state } = useLocation<IContractDetailsState>();
  const { authToken } = useAuth();
  // const [students, setStudents] = useState<IPagination<IUser[]>>({
  //   data: [],
  //   lastPage: 0,
  //   page: 1,
  //   perPage: 1,
  //   total: '0',
  // });
  const [filterModalVisible, setFilterModalVisible] = useState(false);
  const [filterText, setFilterText] = useState('Filtro avançado');
  const [filters, setFilters] = useState<IUserListFilters>({
    start_register_at: '',
    register_status: '',
    payment_status: '',
    search: '',
  });
  const [pageOptions, setPageOptions] = useState<PageOptionsRequest>({
    page: 1,
  });
  const [searchFilter, setSearchFilter] = useState('');
  const [contractHistoricData, setContractHistoricData] = useState<
    IPaymentHistory[] | null
  >(null);

  const handleNavigateToUserDetails = useCallback(
    (user: IUser) => {
      router.push(`/users/details/student/${user.id}`, { user });
    },
    [router],
  );

  const handleNavigateToUserCadaster = useCallback(() => {
    router.push(`/students/cadaster`);
  }, [router]);

  // const handleGetStudents = useCallback(async () => {
  //   // if (!state.currentContractId) return;
  //   try {
  //     setLoading(true);

  //     const { data } = await ProfessionalService.getProfessionalStudents(
  //       268,
  //       pageOptions.page,
  //       9,
  //       filters?.search || undefined,
  //       filters?.register_status || undefined,
  //       filters?.payment_status || undefined,
  //       filters?.start_register_at || undefined,
  //     );
  //     setStudents(data);

  //     setLoading(false);
  //   } catch (error) {
  //     setLoading(false);
  //     toast.error('Profissional com fatura não paga ou cancelada');
  //   }
  // }, [pageOptions.page, setLoading, filters]);

  const handleGetHistoric = useCallback(async () => {
    if (!professionalId) return;
    try {
      setLoading(true);
      const { data } = await PaymentHistoryService.getAllHistoric(
        professionalId,
      );
      if (data) {
        setContractHistoricData(data);
      }
    } catch (error) {
      toast.error('Erro ao buscar contratos.');
    } finally {
      setLoading(false);
    }
  }, [professionalId, setLoading]);

  console.log(professionalId);

  const handleEditStatusContract = useCallback(
    async (contractId: string, status: string) => {
      if (!contractId || !status) return;
      try {
        setLoading(true);
        const { data } = await PaymentHistoryService.editPaymentHistoricStatus(
          contractId,
          {
            status,
          },
        );
        if (data) {
          await handleGetHistoric();
          toast.success('Status atualizado com sucesso');
        }
      } catch (error) {
        toast.error('Erro ao atualizar status.');
      } finally {
        setLoading(false);
      }
    },
    [handleGetHistoric, setLoading],
  );

  // editPaymentHistoricStatus
  // useEffect(() => {
  //   handleGetStudents();
  // }, [handleGetStudents]);

  useEffect(() => {
    handleGetHistoric();
  }, [handleGetHistoric]);

  const applyFilters = async (data: IUserListFilters) => {
    try {
      console.log('data:', data);
      formRef.current?.setErrors({});
      await UserListFiltersSchema.validate(data);
      setFilterText(validateFilterButton);
      setFilters({
        ...data,
        start_register_at: data.start_register_at
          ? moment(data.start_register_at, 'DD-MM-yyyy').format('yyyy-MM-DD')
          : '',
      });
      setFilterModalVisible((prevState) => !prevState);
    } catch (error) {
      console.log(error);
      handleYupValidationError(formRef, error);
    }
  };

  const PaymentHistoricTableMemo = useMemo(
    () => (
      <Table
        noItems={contractHistoricData?.length === 0}
        colsNames={[
          'Número de contrato',
          'Data de pagamento',
          'Valor',
          'Status',
        ]}
      >
        {contractHistoricData?.map((payment) => (
          <tr key={payment.id}>
            <td>#{payment.contract.contract_number}</td>
            <td>{formatUTCDateToBR(payment.payment_date)}</td>
            <td>{applyMask({ name: 'real', value: String(payment.value) })}</td>
            <td>
              <Form
                onSubmit={() => {
                  console.log('status');
                }}
                style={{ width: '60%' }}
              >
                <Select
                  style={{
                    textAlign: 'left',
                    padding: '0 8px',
                    fontSize: '13px',
                  }}
                  containerStyle={{
                    marginBottom: '0',
                    border: '1px solid #000000',
                    height: '40px',
                    position: 'sticky',
                  }}
                  name="status"
                  value={payment.status}
                  options={statusPayment}
                  onChange={(e) => {
                    handleEditStatusContract(
                      String(payment.id),
                      e.target.value,
                    );
                  }}
                />
              </Form>
            </td>

            {/* <td>{payment.status}</td> */}
          </tr>
        ))}
      </Table>
    ),
    [contractHistoricData, handleEditStatusContract],
  );

  // console.log('students:', students);

  const validateFilterButton = (): string => {
    const data = formRef.current?.getData() ?? {};
    let result = 'Filtro avançado';
    Object.values(data).forEach((value) => {
      if (value !== '') {
        result = 'Filtrando';
      }
    });
    return result;
  };

  // console.log('filters:', filters);

  return (
    <>
      <GoBackButton
        containerStyle={{ alignSelf: 'flex-start', paddingTop: '2.2rem' }}
      />
      <S.Container>
        <S.UsersListHeader>
          <S.UserListTitle>HISTÓRICO DE PAGAMENTO</S.UserListTitle>
          {/* <InputSearch
            name="search"
            onSearch={(value) => setSearchFilter(value)}
            placeholder="Buscar por nome, e-mail ou CPF"
          />
          <Button
            onClick={() => setFilterModalVisible((prevState) => !prevState)}
            textContent={filterText}
            size="small"
            extraStyles={{ width: 180 }}
            variant={filterText !== 'Filtrando' ? 'border' : 'yellow'}
            icon={<IoFilterSharp size={20} />}
          />
          <Button
            onClick={() => {
              formRef.current?.reset({
                start_register_at: '',
                register_status: '',
                payment_status: '',
              });
              setFilters({});
              setFilterText('Filtro avançado');
            }}
            buttonDisable={filterText !== 'Filtrando'}
            textContent="Limpar filtros"
            size="small"
            variant="black"
          /> */}
        </S.UsersListHeader>
        {PaymentHistoricTableMemo}
        <S.UsersListFooter>
          {/* <Button
            onClick={handleNavigateToUserCadaster}
            textContent="Cadastrar treinador"
            size="small"
            variant="black"
            extraStyles={{
              maxWidth: 300,
            }}
          /> */}
          {/* <Pagination
            pageCount={students.lastPage!}
            pageRangeDisplayed={3}
            {...{ setPageOptions }}
          /> */}
        </S.UsersListFooter>
      </S.Container>
      <ConfirmModal
        modalIsVisible={filterModalVisible}
        setModalIsVisible={() =>
          setFilterModalVisible((prevState) => !prevState)
        }
        handleSubmit={() => formRef.current?.submitForm()}
        title="Filtro avançado"
        confirmText="Aplicar filtros"
      >
        <FilterForm
          handleSubmit={applyFilters}
          formName="students-filters"
          formRef={formRef}
        />
      </ConfirmModal>
    </>
  );
};

export default PaymentHistoric;
